"use client";

import { useInheritedFormMode } from "./inherited-form-mode";

export function useFormModeGuard(disabled = false) {
  const { isHistoric, isInherited, sideEffectsAllowed } = useInheritedFormMode();
  const readOnly = disabled || isInherited;

  return {
    readOnly,
    isInherited,
    isHistoric,
    sideEffectsAllowed: sideEffectsAllowed && !disabled,
    disabled,
  };
}
